import {
  GET_EMPLOYEE_ROLES_REQUESTED,
  GET_EMPLOYEE_ROLES_SUCCEEDED,
  GET_EMPLOYEE_ROLES_FAILED,
    CREATE_EMPLOYEE_ROLE_SUCCEEDED,
  } from './constants'
import { keyBy } from 'lodash'

export const defaultState = {
    byEmployeeId: {}
}

export default (state = defaultState, { payload, type }) => {
  switch (type) {
    case GET_EMPLOYEE_ROLES_REQUESTED: {
      return {
        ...state,
        isLoading: true
      }
    }
    case GET_EMPLOYEE_ROLES_SUCCEEDED: {
      const byEmployeeId = keyBy(payload, 'employeeId')

      return {
        ...state,
        isLoading: false,
        byEmployeeId: {
          ...state.byEmployeeId,
          ...byEmployeeId
        }
      }
    }

    case GET_EMPLOYEE_ROLES_FAILED: {
      return {
        ...state,
        isLoading: false
      }
    }

    case CREATE_EMPLOYEE_ROLE_SUCCEEDED: {
      const byEmployeeId = keyBy(payload?.employeeRoles, 'employeeId')

      return {
        ...state,
        byEmployeeId: {
          ...state.byEmployeeId,
          ...byEmployeeId
        }
      }
    }

    default:
      return state
  }
}
